const IceCube = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M14.9012 0.0837988C16.0956 -0.210671 17.3427 0.286408 18.0311 1.33163L23.494 9.62838C23.7747 10.0546 23.9398 10.5391 23.9863 11.0349L12.3125 14.2332L4.63787 2.97053C5.00689 2.61568 5.38855 2.42915 5.89056 2.30538L14.9012 0.0837988Z"
        fill="#9FABFD"
      />
      <path
        d="M12.3125 14.2332L7.50385 23.812C6.91291 23.5946 6.38963 23.1846 6.02879 22.6167L0.479502 13.8836C-0.108897 12.9575 -0.159394 11.7756 0.348023 10.8003L3.97824 3.82269C4.148 3.49641 4.37261 3.20882 4.63787 2.97053L12.3125 14.2332Z"
        fill="#5776FC"
      />
      <path
        d="M23.9863 11.0349C24.0353 11.5564 23.9532 12.0898 23.7345 12.5822L20.7233 19.3639C20.4323 20.0194 19.9256 20.5413 19.3004 20.8447L17.5538 21.407L9.32148 23.8692C8.68602 24.0592 8.09127 24.0439 7.50385 23.812L12.3125 14.2332L23.9863 11.0349Z"
        fill="#7D91FD"
      />
      <path
        d="M19.001 19.1082C19.2144 18.936 19.5234 18.9741 19.691 19.1933L20.3263 20.0201C20.3263 20.0201 20.137 20.2449 19.9988 20.371C19.8502 20.5064 19.5906 20.6829 19.5906 20.6829L18.9181 19.8171C18.7505 19.5979 18.7876 19.2805 19.001 19.1082Z"
        fill="#FFF5EB"
      />
      <path
        d="M15.9981 15.182C16.2115 15.0098 16.5205 15.0479 16.6881 15.2671L18.4041 17.5107C18.5717 17.7299 18.5346 18.047 18.3212 18.2193C18.1078 18.3915 17.7988 18.3537 17.6312 18.1345L15.9156 15.8909C15.7479 15.6717 15.7848 15.3543 15.9981 15.182Z"
        fill="#FFF5EB"
      />
      <path
        d="M12.9955 11.2561C13.2089 11.0839 13.5179 11.1217 13.6855 11.3409L15.4012 13.5845C15.5688 13.8037 15.532 14.1211 15.3186 14.2934C15.1053 14.4656 14.7963 14.4274 14.6286 14.2083L12.9127 11.9647C12.7451 11.7454 12.7822 11.4283 12.9955 11.2561Z"
        fill="#FFF5EB"
      />
      <path
        d="M0.767699 12.0254C1.02399 11.9339 1.30393 12.0731 1.3931 12.3363C1.48225 12.5997 1.34679 12.8872 1.09048 12.9788L0.189873 13.2974C0.189873 13.2974 0.0908089 13.0004 0.0537359 12.8036C0.0170614 12.6089 0.000813564 12.2988 0.000813564 12.2988L0.767699 12.0254Z"
        fill="#FFF5EB"
      />
      <path
        d="M4.53483 10.6794C4.79112 10.5878 5.07106 10.727 5.16024 10.9902C5.24939 11.2536 5.11392 11.5411 4.85761 11.6327L2.70501 12.4021C2.44872 12.4936 2.16878 12.3544 2.07961 12.0912C1.99045 11.8279 2.12592 11.5403 2.38223 11.4487L4.53483 10.6794Z"
        fill="#FFF5EB"
      />
      <path
        d="M8.30196 9.33326C8.55825 9.24169 8.83819 9.38088 8.92737 9.64415C9.01652 9.90746 8.88105 10.195 8.62474 10.2866L6.47214 11.056C6.21585 11.1475 5.93591 11.0083 5.84674 10.7451C5.75759 10.4818 5.89305 10.1942 6.14936 10.1026L8.30196 9.33326Z"
        fill="#FFF5EB"
      />
      <path
        d="M11.5902 7.29079C11.7427 7.0603 12.0481 7.00044 12.2726 7.15703C12.497 7.31364 12.5554 7.62741 12.4031 7.85801L11.7623 8.82683L12.3986 9.65828C12.5662 9.87748 12.5291 10.1949 12.3157 10.3671C12.1024 10.5394 11.7934 10.5012 11.6257 10.282L10.9843 9.44368L10.2393 9.70988C9.98299 9.80145 9.70305 9.66226 9.61387 9.39899C9.52472 9.13568 9.66018 8.84809 9.9165 8.7565L10.8388 8.42655L11.5902 7.29079Z"
        fill="#FFF5EB"
      />
      <path
        d="M14.5384 2.83185C14.6909 2.60137 14.9963 2.5415 15.2207 2.69809C15.4452 2.8547 15.5036 3.16847 15.3513 3.39907L13.6664 5.94732C13.5138 6.1778 13.2084 6.23767 12.984 6.08108C12.7596 5.92446 12.7011 5.6107 12.8535 5.38009L14.5384 2.83185Z"
        fill="#FFF5EB"
      />
      <path
        d="M17.2498 0.526074L16.6145 1.48838C16.462 1.71887 16.1566 1.77873 15.9322 1.62214C15.7078 1.46553 15.6493 1.15176 15.8017 0.921157L16.3954 0.115557C16.3954 0.115557 16.5946 0.170005 16.7604 0.249374C16.9296 0.330302 17.2498 0.526074 17.2498 0.526074Z"
        fill="#FFF5EB"
      />
    </svg>
  );
};

export default IceCube;
